<template>
  <div>
    <mt-header title="壹签" v-model="popupVisible">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
      <mt-button icon="more" slot="right"
         ></mt-button>
    </mt-header>
  </div>
</template>

<script>
export default {
  name: 'dtrqs',
  data () {
    return {

    }
  },
  methods: {
    goback: function () {
      history.go(-1); //后退1页
    }
  }
}
</script>

<style>
.mint-header .mint-header-title {
    font-size: 1.1rem;
}
</style>





// WEBPACK FOOTER //
// src/components/header.vue